<script>
export default {
    computed: {
        isMobileScreen() {
            return this.$mq === 'sm' || this.$mq === 'md' ? true : false;
        },
    },
};
</script>

<style lang="scss" scoped></style>
